import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { School } from '../models/school.model';
import { SchoolResponse } from '../models/school-response.model';
import { SchoolAddModel } from '../models/school-add-model';
import { SchoolManagement, SchoolManagementRequest } from '../models/school-management.model';
import { SchoolMonitorResponse } from '../models/school-monitor.model';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  private apiUrl = `${environment.sgcApi}`;
  private schoolRoute = 'school';

  constructor(
    private httpClient: HttpClient
  ) {}

  getSchoolsMap(zoneId: number, profitCenterCode: string, exerciseId: number, user: string, contractType?: boolean) : Observable<School[]> {
    let zoneIdParam = (zoneId != null && !isNaN(zoneId) && zoneId != 0) ? zoneId.toString() : "";
    let profitCenterCodeParam = profitCenterCode.trim()  != "" ? profitCenterCode : "";
    let endpoint = `${this.apiUrl}${this.schoolRoute}/user/${user}/filters/map${this.getFilters(zoneIdParam, profitCenterCodeParam, exerciseId, contractType)}`;
    return this.httpClient.get<School[]>(endpoint)
    .pipe(map((schools) => {
      return plainToInstance(School, schools as School[]);
    }));
  }

  getSchools(zoneId: number, centerCode: string, exerciseId: number, user: string) : Observable<SchoolResponse[]> {
    let zoneIdParam = zoneId.toString().trim()  != "" ? zoneId.toString() : "";
    let centerCodeParam = centerCode.trim()  != "" ? centerCode : "";
    let endpoint = `${this.apiUrl}${this.schoolRoute}/user/${user}${this.getFilters(zoneIdParam, centerCodeParam, exerciseId)}`;
    return this.httpClient.get<SchoolResponse[]>(endpoint)
    .pipe(map((schools) => {
      return plainToInstance(SchoolResponse, schools as SchoolResponse[]);
    }));
  }

  getSchoolDetails(schoolId: number, exerciseId: number) {
    let endpoint = `${this.apiUrl}${this.schoolRoute}/managment/schoolId/${schoolId}/exerciseId/${exerciseId}`;
    return this.httpClient.get<SchoolManagement>(endpoint)
    .pipe(map((schools) => {
      return plainToInstance(SchoolManagement, schools as SchoolManagement);
    }));
  }

  createSchool(school: SchoolAddModel, user: string) {
    let endpoint = `${this.apiUrl}${this.schoolRoute}/user/${user}`;
    return  this.httpClient.post<any>(endpoint, school).pipe(
      map(data => data)
    );
  }

  updateSchool(school: SchoolManagementRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.schoolRoute}/user/${user}`;
    return  this.httpClient.put<SchoolManagementRequest>(endpoint, school).pipe(
      map(data => data)
    );
  }

  getSchoolsForMonitors(exerciseId: number, user: string) {
    let endpoint = `${this.apiUrl}${this.schoolRoute}/user/${user}/exerciseId/${exerciseId}/monitor`;
    return this.httpClient.get<SchoolMonitorResponse[]>(endpoint)
    .pipe(map((schools => schools)));
  }

  private getFilters (
    zoneId: string,
    centerCode: string,
    exerciseId?: number,
    contractType?: boolean
  ) {
    let urlFilter = "/?filters=";
    urlFilter += zoneId != "" ? "zoneId=" + zoneId + ";" : "";
    urlFilter += centerCode != "" ? "profitCenterCode=" + centerCode + ";" : "";
    urlFilter += exerciseId?.toString() != "" ? "exerciseId=" + exerciseId + ";" : "";
    urlFilter += contractType !== undefined ? "contractType=" + contractType : "";
    urlFilter = urlFilter.endsWith(";") ? urlFilter.slice(0, -1) : urlFilter;
    return urlFilter
  }
}
